import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="bonos-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-27" data-mp="pm2bbv98hdgi">
      <div className="mx-auto max-w-6xl px-6" data-id="element-28" data-mp="ftmr0ragscsg">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.8fr)] lg:items-end" data-id="element-29" data-mp="fsbsp6zsfx8q">
          <Reveal data-id="element-30" data-mp="1t3pm30i84z9">
            <p className="inline-flex items-center gap-2 rounded-full bg-mint-50 px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200" data-id="element-31" data-mp="1wrh6wme2hbc">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="3o368sdzxmyfq" />
              Incluidos en el Megapack
            </p>
            <h2 id="bonos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-33" data-mp="3t2sm0nfrgeoj">
              Además, 5 bonos prácticos
            </h2>
            <p className="mt-4 max-w-xl text-lg text-ink-soft" data-id="element-34" data-mp="1r8tdg9u0wbfj">
              Herramientas para aplicar la ruta en la vida real: la compra, las
              salidas, los viajes y los días con más malestar.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-35" data-mp="3r6qhck1lsahk">
            <img src="https://cdn.magicpatterns.com/uploads/w2euMroWfvQtfTbdfisj6n/e917eb8e-922b-4b66-99bf-315fb96d2d3a_(1).webp" alt="Portadas de los 5 bonos del Megapack" className="w-full rounded-2xl bg-mint-50 object-cover" width={900} height={600} loading="lazy" decoding="async" data-id="element-36" data-mp="3r5ovdkj1u3l2" />
            <p className="mt-3 text-xs text-ink-muted" data-id="element-37" data-mp="2uh0va37ah0zx">
              Imagen ilustrativa. Los bonos se entregan en formato PDF.
            </p>
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-38" data-mp="33h5o98bqjwuk">
          {bonos.map((bono, index) => <li key={bono.number} className="flex" data-id="element-39" data-mp="nq1eb818biwn" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col rounded-2xl border border-mint-200 bg-mint-50/60 p-7" data-id="element-40" data-mp="nogfh67vtdsz">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-mint-600" data-id="element-41" data-mp="3ciwryrwu9nk7">
                  Bono {bono.number}
                </p>
                <h3 className="mt-3 font-display text-xl leading-snug text-ink" data-id="element-42" data-mp="3hgoh5e63mvkp">
                  {bono.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-43" data-mp="3lhi9qkuhkyjx">
                  {bono.description}
                </p>
                <p className="mt-auto pt-6 text-sm font-semibold text-mint-700" data-id="element-44" data-mp="2tsyic7de7meg">
                  Incluido
                </p>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.04} data-id="element-45" data-mp="32t3h5t4itch0">
          <p className="mt-10 rounded-2xl bg-mint-600 px-8 py-6 text-center text-lg font-medium text-white" data-id="element-46" data-mp="32sv5u5o1qf7x">
            Los 5 bonos forman parte del Megapack completo, sin coste adicional.
          </p>
        </Reveal>
      </div>
    </section>;
}